module.exports = __webpack_public_path__ + "static/media/iemlogo.ff27700a.png";